// extracted by mini-css-extract-plugin
export default {"circle":"Circle_circle__5ZpSd","red":"Circle_red__k8VqT","blue":"Circle_blue__xsoKQ","inside":"Circle_inside__AjGl7"};